import i18n from 'live/services/i18n'

import { IBarrierType, IPaginatedREST } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IBarrierTypesListFilters {}

export interface IBarrierTypeCreation {
    name: string
    description: string
    iconReference: string
}

interface IParams {
    perPage?: number
    page?: number
    keyword?: string
    orderBy?: string
    direction?: string
}

export const listBarrierTypes = async (params?: IParams): Promise<IPaginatedREST<IBarrierType>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString()?.toUpperCase() ?? 'ID',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierTypes}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getBarrierType = async (id: number): Promise<IBarrierType> => {
    if (!id) {
        return undefined
    }

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierTypes}/${id}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createBarrierType = async <COPY extends boolean = false>(
    data: COPY extends true ? { id: number } : IBarrierTypeCreation,
    copy?: COPY
): Promise<IBarrierType> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierTypes}/${copy ? '?copy=true' : ''}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const deleteBarrierType = async (id: number): Promise<void> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierTypes}/${id}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(
                jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? i18n('Error on delete barrier category')
            )
        }
    })
}

export const updateBarrierType = async (barrierType: IBarrierType): Promise<IBarrierType> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.barrierTypes}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(barrierType)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
